import { render } from "./CitySwiper.vue?vue&type=template&id=cc529334&scoped=true"
import script from "./CitySwiper.vue?vue&type=script&lang=js"
export * from "./CitySwiper.vue?vue&type=script&lang=js"

import "./CitySwiper.vue?vue&type=style&index=0&id=cc529334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc529334"]])

export default __exports__